import { render, staticRenderFns } from "./FormColorSelector.vue?vue&type=template&id=1dd161fe&scoped=true&"
import script from "./FormColorSelector.vue?vue&type=script&lang=js&"
export * from "./FormColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./FormColorSelector.vue?vue&type=style&index=0&id=1dd161fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd161fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
